import { handleUpdateRideRequestList } from 'api-service/ride-request';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { handleRefundRequestList } from 'api-service/refund';

export const useBookings = () => {
  const [bookings, setBookings] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { id } = useParams();
  const [isRide, setIsRide] = useState(
    location.pathname.includes('ride-bookings')
  );

  const getBookings = async () => {
    let responseObject;
    if (isRide) {
      const response = JSON.parse(
        sessionStorage.getItem(`driverRideBookings${id}`)
      );
      responseObject = [
        ...response.riderRideRequest,
        ...response.driverRideRequest
      ];
    } else {
      const response = JSON.parse(
        sessionStorage.getItem(`driverHotelBookings${id}`)
      );
      responseObject = [
        ...response.userPropertyRequest,
        ...response.hotelPropertyRequest
      ];
    }
    const requestDataList = responseObject;
    setBookings(requestDataList);
    setIsLoading(false);
  };

  const updateRideRequestList = async (id, status) => {
    await handleUpdateRideRequestList(id, status);
    const updatedStatus = status;
    const newArr = [];
    bookings.forEach(el => {
      if (el.id == id) {
        el.status = updatedStatus.status;
        newArr.push(el);
      } else {
        newArr.push(el);
      }
    });
    setBookings(newArr);
  };

  const refundBooking = async body => {
    await handleRefundRequestList(body);
  };

  useEffect(() => {
    if (location.pathname.includes('ride-bookings')) {
      getBookings();
      setIsRide(isRide);
    } else {
      getBookings();
    }
  }, []);

  return {
    isLoading,
    bookings,
    updateRideRequestList,
    refundBooking,
    isRide
  };
};
